<template>
    <div class="block-add-cards d-flex">
        <div class="btn-blocks-wrapper">
        <ul :class="{open: listOpen}">
            <!--<li>-->
            <!--<button class="btn btn-default" @click="AddGoToCard"  >-->
            <!--<img src="../../../assets/img/ic_go_to_block_round.png" alt="">-->
            <!--<span>Go To Block</span>-->
            <!--</button>-->
            <!--</li>-->
            <li>
                <button class="btn btn-default" @click="AddTextCard">
                    <img src="../../../assets/img/ic_textcard.png" alt="">
                    <span>text </span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddimageURlCard">
                    <img src="../../../assets/img/ic_gallery-sm.png" alt="">
                    <span>URL</span>
                </button>
            </li>
            <!--<li>-->
            <!--<button class="btn btn-default" @click="AddAudioCard">-->
            <!--<img src="../../../assets/img/ic_audio_round.png" alt="">-->
            <!--<span>audio</span>-->
            <!--</button>-->
            <!--</li>-->
            <!--<li>-->
            <!--<button class="btn btn-default" @click="AddTypingCard">-->
            <!--<img src="../../../assets/img/ic_typing-sm.png" alt="">-->
            <!--<span>typing</span>-->
            <!--</button>-->
            <!--</li>-->
            <li>
                <button class="btn btn-default"  @click="AddImageCard">
                    <img src="../../../assets/img/ic_image.png" alt="">
                    <span>image</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddGalleryCard">
                    <img src="../../../assets/img/ic_gallery-sm.png" alt="">
                    <span>gallery</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddVideoCard">
                    <img src="../../../assets/img/ic_video_round.png" alt="">
                    <span>video</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddgifCard">
                    <img src="../../../assets/img/ic_gallery-sm.png" alt="">
                    <span>gif</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddSuggestedCard"  data-dismiss="modal">
                    <img src="../../../assets/img/conversation.png" width="50px" alt="">
                    <span>Suggestion</span>
                </button>
            </li>



            <li>
                <button class="btn btn-default" @click="AddGoToCard2"  >
                    <img src="../../../assets/img/ic_go_to_block_round.png" alt="">
                    <span>If Else</span>
                </button>
            </li>


            <li>
                <button class="btn btn-default" @click="AddAudioCard">
                    <img src="../../../assets/img/ic_audio_round.png" alt="">
                    <span>audio</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddTypingCard">
                    <img src="../../../assets/img/ic_typing-sm.png" alt="">
                    <span>typing</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddAttrubiteCard"  >
                    <img src="../../../assets/img/attribute.png"  alt="">
                    <span>Attribute</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddUserInput"  >
                    <img src="../../../assets/img/ic_r_forms@2x.png"  alt="">
                    <span>User Input</span>
                </button>

            </li>
            <li>
                <button class="btn btn-default" @click="AddJsonCard" >
                    <img   src="../../../assets/img/ic_r_json.png"/>
                    <span>Json</span>
                </button>
            </li>
            <!--<li>-->
            <!--<button class="btn btn-default" @click="AddListCard"  >-->
            <!--<img src="../../../assets/img/List.png"  alt="">-->
            <!--<span>List</span>-->
            <!--</button>-->
            <!--</li>-->
            <li>
                <button class="btn btn-default" @click="AddRandom"  >
                    <img src="../../../assets/img/Random.png"  alt="">
                    <span>Random</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddBillingCard" >
                    <img   src="../../../assets/img/coin.png"/>
                    <span>billing</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddTravelCard"  >
                    <img src="../../../assets/img/travel.png"  alt="">
                    <span>travel</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="AddFlightCard"  >
                    <img src="../../../assets/img/airplane.png"  alt="">
                    <span>Flight Status</span>
                </button>
            </li>
            <li>
                <button class="btn btn-default" @click="addWeatherCard" >
                    <img src="../../../assets/img/weather.png" alt="">
                    <span>Weather</span>
                </button>
            </li>

            <!--<li>-->
            <!--<button class="btn btn-default" @click="AddSuggestedCard"  >-->
            <!--<img src="../../../assets/img/ic_textcard.png"  alt="">-->
            <!--<span>Suggested</span>-->
            <!--</button>-->
            <!--</li>-->
        </ul>
        </div>
        <button class="open-btn-blocks" :class="{openBtn: listOpen}" @click="listOpen = !listOpen">
            <i class="material-icons" >add</i>
            Add Block
        </button>
    </div>
</template>

<script>
    export default {
        name: "add-block",
        props: {
            blocks: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data() {
            return {
                listOpen: false
            }
        },
        methods: {
            AddTextCard(){

                this.blocks.payload.push({
                    block_id:1,
                    data:{
                        text:'',
                        buttons:[
                        ]
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddSuggestedCard(){

                this.blocks.payload.push({
                    block_id:17,
                    data:{
                        text:'',
                        buttons:[
                            {
                                block_id: '',
                                errorOrEmpty: "",
                                phone: "",
                                title: "Untitled Button",
                                type: "block",
                                url: ""
                            }
                        ]
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddAudioCard(){
                this.blocks.payload.push({
                    block_id:6,
                    data:{
                        url:''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddimageURlCard(){
                this.blocks.payload.push({
                    block_id:15,
                    data:{
                        url:'',
                        text:''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddgifCard(){
                this.blocks.payload.push({
                    block_id:16,
                    data:{
                        url:'',
                        text:'',
                        subtitle:''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddTypingCard(){
                this.blocks.payload.push({
                    block_id:8,
                    data:{
                        for:100
                    },
                    errorOrEmpty:1
                })
                this.listOpen = false
            },
            AddImageCard(){
                this.blocks.payload.push({
                    block_id:3,
                    data:{
                        url:''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddGalleryCard(){
                this.blocks.payload.push({
                    block_id:4,
                    data:{
                        items:[
                            {
                                url:'',
                                header:'',
                                subtitle:'',
                                imageUrl:'',
                                buttons:[

                                ]
                            }
                        ],
                        errorOrEmpty:0
                    }
                })
                this.listOpen = false
            },
            AddVideoCard(){
                this.blocks.payload.push({
                    block_id:5,
                    data:{
                        url:''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddGoToCard(){
                this.blocks.payload.push({
                    block_id:7,
                    data:{
                        filter:[],
                        blocks:[{
                            blocks:[]
                        }],
                        random:false
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddAttrubiteCard(){
                this.blocks.payload.push({
                    block_id:10,
                    data:{
                        attributes:[
                            {
                                id:0,
                                attribute:'',
                                value:''
                            }
                        ]
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddListCard(){
                this.blocks.payload.push({
                    block_id:13,
                    data:{
                        image:'',
                        items:[
                            {
                                header:'',
                                subtitle:'',
                                url:'',
                                image:'',
                                buttons:[

                                ]
                            }
                        ],
                        buttons:[

                        ]
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddUserInput(){
                this.blocks.payload.push({
                    block_id:11,
                    data:{
                        items:[
                            {
                                message:'',
                                validation:'',
                                save_to_attribute:'',
                                userAttribute: '',
                                regex:'',
                                errorMsg: ''
                            }
                        ],

                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddJsonCard(){
                this.blocks.payload.push({
                    block_id:12,
                    data:{
                        type:'get',
                        url:'',
                        user_attribute:[],
                        report:false,
                        attributeFields:[],
                        headers: []
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddRandom(){
                this.blocks.payload.push({
                    block_id:14,
                    data:{
                        from : 100,
                        to: 200,
                        userAttribute:''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddGoToCard2(){
                this.blocks.payload.push({
                    block_id:18,
                    data:{
                        cards:[
                            {
                                filter:[
                                    {
                                        attribute:'',
                                        operator:'is',
                                        value:'',
                                        condition:'or'
                                    }
                                ],
                                blocks:[{
                                    blocks:[]
                                }],
                                random:false
                            }
                        ]
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddTravelCard(){
                this.blocks.payload.push({
                    block_id:20,
                    data:{
                        passengers:'ahmed',
                        passengersText:'passengers',
                        passengerTitle:'passengers',
                        stopsNumber:50,
                        total: '$4,032.54',
                        totalText: 'total',
                        stops:{
                            date:'',
                            time:'',
                            originName:'San Francisco',
                            destName:'Amsterdam',
                            originAcronym:'SFO',
                            destAcronym:'AMS',
                        },
                        nonStops:{
                            date:'',
                            time:'',
                            nonStopsText:'',
                            originName:'Amsterdam',
                            destName:'San Francisco',
                            originAcronym:'AMS',
                            destAcronym:'SFO',
                        }
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            AddFlightCard() {
                this.blocks.payload.push({
                    block_id: 22,
                    data: {
                        status: 'DELAY',
                        passengers: [
                            {passenger: 'aml', seat: '12A'},
                            {passenger: 'ahmed', seat: '34b'}
                        ],
                        flight: 'KL0605',
                        departs: '10:10AM',
                        arrives: '10:10AM',
                        travel: {
                            originName: 'San Francisco',
                            destName: 'Amsterdam',
                            originAcronym: 'SFO',
                            destAcronym: 'AMS',
                        }
                    },
                    errorOrEmpty: 0
                })
                this.listOpen = false
            },
            AddBillingCard(){
                this.blocks.payload.push({
                    block_id: 19,
                    data:{
                        speak:'',
                        horizontalAlignment:'left',
                        lang:'en',
                        image:'',
                        title: '',
                        first_row: {
                            title: '',
                            value: ''
                        },
                        second_row: [
                            {title: '', value: ''},
                            {title: '', value: ''},
                            {title: '', value: ''},
                            {title: '', value: ''}
                        ],
                        third_row: [
                            {title: '', value: ''},
                            {title: '', value: ''},
                            {title: '', value: ''},
                            {title: '', value: ''}
                        ],
                        fourth_row: {title: '', value: ''}
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            },
            addWeatherCard () {
                this.blocks.payload.push({
                    block_id:21,
                    data:{
                        area: '',
                        imageUrl: '',
                        temp: '',
                        hiTemp: '',
                        lowTemp: ''
                    },
                    errorOrEmpty:0
                })
                this.listOpen = false
            }
        }
    }
</script>

<style scoped>

</style>